export default __webpack_public_path__ + "static/media/CEO pic9.27d46461.png";